/* 
  --------------------------------------------------
  DEPRECATED - REMOVED SOON
  In buyers-guide articles there should always be an h2 tag, introducing the quality features.
  This h2 tag contains the substring "qualitätsmerkmale", and by the Rte parsing an ID is genereated for every h2 tag.
  So we look for an element in the DOM with the id that contains the string "qualitatsmerkmale".
  --------------------------------------------------
*/
const qualityFeaturesHeading = document.querySelector('[id*="qualitatsmerkmale"]');
const qualityFeaturesShortcutButton = document.querySelector('[data-anchor="quality-features"]');
if (qualityFeaturesShortcutButton && qualityFeaturesHeading) {
  if (qualityFeaturesHeading && qualityFeaturesShortcutButton) {
    qualityFeaturesShortcutButton.href = '#' + qualityFeaturesHeading.id;
  } else {
    qualityFeaturesShortcutButton.style.display = 'none';
  }
}